import ExperimentOperationSetResourceInstance from "../../../../resources/expapiunified/ExperimentOperationSet.resource.js";
import { createUnifiedRestApi } from "../utils.js";
const builder = createUnifiedRestApi(
  ExperimentOperationSetResourceInstance,
  "operation-sets",
  (state) => state.experimentOperationSets
);
const {
  actions: executeActions,
  selectAsyncRequest: selectExecuteExperimentOperationSetAsyncRequest,
  isOfType: isExecuteExperimentOperationSet
} = builder.addCreateOrUpdateAction(
  "EXECUTE_ASYNC",
  (inputpayload) => ExperimentOperationSetResourceInstance.executeAsync(inputpayload.workspaceId, inputpayload.id)
);
const executeExperimentOperationSetAsync = (inputPayload) => executeActions.load({ workspaceId: inputPayload.workspaceId, id: inputPayload.id, entity: void 0 });
const resetExecuteExperimentOperationSetAsync = (inputPayload) => executeActions.reset({ workspaceId: inputPayload.workspaceId, id: inputPayload.id, entity: void 0 });
const {
  actions: executeEmergencyShutdownActions,
  selectAsyncRequest: selectEmergencyShutdownExecuteExperimentOperationSetAsyncRequest,
  isOfType: isExecuteEmergencyShutdownExperimentOperationSet
} = builder.addCreateOrUpdateAction(
  "EXECUTE_EMERGENCY_SHUTDOWN_ASYNC",
  (inputpayload) => ExperimentOperationSetResourceInstance.executeEmergencyShutdownAsync(inputpayload.workspaceId, inputpayload.id)
);
const executeEmergencyShutdownExperimentOperationSetAsync = (inputPayload) => executeEmergencyShutdownActions.load({ workspaceId: inputPayload.workspaceId, id: inputPayload.id, entity: void 0 });
const resetEmergencyShutdownExecuteExperimentOperationSetAsync = (inputPayload) => executeEmergencyShutdownActions.reset({ workspaceId: inputPayload.workspaceId, id: inputPayload.id, entity: void 0 });
const {
  actions: executeByOperationsActions,
  selectAsyncRequest: selectExecuteByOperationsAsyncRequest,
  isOfType: isExecuteByOperations
} = builder.addMiscellaneousAction(
  "EXECUTE_BY_OPERATIONS_ASYNC",
  (inputPayload) => ExperimentOperationSetResourceInstance.executeByOperationsAsync(
    inputPayload.workspaceId,
    inputPayload.entity.experimentOperations
  )
);
const executeByOperationsAsync = executeByOperationsActions.load;
const resetExecuteByOperationsAsync = executeByOperationsActions.reset;
const {
  actions: executeEmergencyShutdownByOperationsActions,
  selectAsyncRequest: selectExecuteEmergencyShutdownByOperationsAsyncRequest,
  isOfType: isExecuteEmergencyShutdownByOperations
} = builder.addMiscellaneousAction(
  "EXECUTE_EMERGENCY_SHUTDOWN_BY_OPERATIONS_ASYNC",
  (inputPayload) => ExperimentOperationSetResourceInstance.executeEmergencyShutdownByOperationsAsync(
    inputPayload.workspaceId,
    inputPayload.entity.experimentOperations
  )
);
const executeEmergencyShutdownByOperationsAsync = executeEmergencyShutdownByOperationsActions.load;
const resetExecuteEmergencyShutdownByOperationsAsync = executeEmergencyShutdownByOperationsActions.reset;
const {
  actions: getOperationCheckBySetIdActions,
  selectAsyncRequest: selectGetOperationCheckBySetIdAsyncRequest,
  isOfType: isGetOperationCheckBySetId
} = builder.addGetAction(
  "GET_OPERATION_CHECKS_BY_ID_ASYNC",
  (inputPayload) => ExperimentOperationSetResourceInstance.getOperationCheckByOperationSetIdAsync(inputPayload.workspaceId, inputPayload.id)
);
const getOperationCheckBySetIdAsync = getOperationCheckBySetIdActions.load;
const resetGetOperationCheckBySetIdAsync = getOperationCheckBySetIdActions.reset;
const {
  actions: getOperationCheckByOperationsActions,
  selectAsyncRequest: selectGetOperationCheckByOperationsAsyncRequest,
  isOfType: isGetOperationCheckByOperations
} = builder.addMiscellaneousAction(
  "GET_OPERATION_CHECKS_BY_OPERATIONS_ASYNC",
  (inputPayload) => ExperimentOperationSetResourceInstance.getOperationCheckByOperations(inputPayload.workspaceId, inputPayload.entity)
);
const getOperationCheckByOperationsAsync = getOperationCheckByOperationsActions.load;
const resetGetOperationCheckByOperationsAsync = getOperationCheckByOperationsActions.reset;
const {
  epic: experimentOperationSetsEpic,
  reducer: experimentOperationSetsReducer,
  actions: experimentOperationSetsActions,
  selectors,
  getDefaultReducerState: getDefaultExperimentOperationSetsReducerState
} = builder.create();
const {
  selectAll: selectAllExperimentOperationSets,
  selectById: selectExperimentOperationSetById,
  selectGetAsyncRequest: selectGetExperimentOperationSetAsyncRequest,
  selectQueryAsyncRequest: selectQueryExperimentOperationSetsAsyncRequest,
  selectCreateOrUpdateAsyncRequest: selectCreateOrUpdateExperimentOperationSetAsyncRequest,
  selectDeleteAsyncRequest: selectDeleteExperimentOperationSetAsyncRequest
} = selectors;
const {
  getAsync: getExperimentOperationSetAsync,
  queryAsync: queryExperimentOperationSetsAsync,
  createOrUpdateAsync: createOrUpdateExperimentOperationSetAsync,
  deleteAsync: deleteExperimentOperationSetAsync
} = experimentOperationSetsActions;
export {
  createOrUpdateExperimentOperationSetAsync,
  deleteExperimentOperationSetAsync,
  executeByOperationsAsync,
  executeEmergencyShutdownByOperationsAsync,
  executeEmergencyShutdownExperimentOperationSetAsync,
  executeExperimentOperationSetAsync,
  experimentOperationSetsEpic,
  experimentOperationSetsReducer,
  getDefaultExperimentOperationSetsReducerState,
  getExperimentOperationSetAsync,
  getOperationCheckByOperationsAsync,
  getOperationCheckBySetIdAsync,
  isExecuteByOperations,
  isExecuteEmergencyShutdownByOperations,
  isExecuteEmergencyShutdownExperimentOperationSet,
  isExecuteExperimentOperationSet,
  isGetOperationCheckByOperations,
  isGetOperationCheckBySetId,
  queryExperimentOperationSetsAsync,
  resetEmergencyShutdownExecuteExperimentOperationSetAsync,
  resetExecuteByOperationsAsync,
  resetExecuteEmergencyShutdownByOperationsAsync,
  resetExecuteExperimentOperationSetAsync,
  resetGetOperationCheckByOperationsAsync,
  resetGetOperationCheckBySetIdAsync,
  selectAllExperimentOperationSets,
  selectCreateOrUpdateExperimentOperationSetAsyncRequest,
  selectDeleteExperimentOperationSetAsyncRequest,
  selectEmergencyShutdownExecuteExperimentOperationSetAsyncRequest,
  selectExecuteByOperationsAsyncRequest,
  selectExecuteEmergencyShutdownByOperationsAsyncRequest,
  selectExecuteExperimentOperationSetAsyncRequest,
  selectExperimentOperationSetById,
  selectGetExperimentOperationSetAsyncRequest,
  selectGetOperationCheckByOperationsAsyncRequest,
  selectGetOperationCheckBySetIdAsyncRequest,
  selectQueryExperimentOperationSetsAsyncRequest
};
//# sourceMappingURL=experiment-operation-sets.js.map
